import { SplitLibrarySplitKind } from "@redotech/redo-model/checkouts/splits/split-library";
import * as z from "zod/v4";

export const getSplitLibrarySplits = {
  name: "getSplitLibrarySplits" as const,
  input: z.null(),
  output: z.object({
    splits: z.array(
      z.object({
        kind: z.enum(SplitLibrarySplitKind),
        title: z.string(),
        description: z.string(),
      }),
    ),
  }),
};
